import React from 'react';

import Button from '../../UI/Button/Button';
import LanguageSwitch from '../../../containers/LanguageSwitch/LanguageSwitchContainer';
import strings from '../../../assets/localization';
import classes from './HiddenNavBar.module.css';

const hiddenNavBar = (props) => (
  // console.log('NAV BARR ::::', props),

  <div style={props.style} className={classes.HiddenNavBar}>
    <div className={classes.LanguageSwitch}><LanguageSwitch /></div>
    <div className={classes.LogoWrapper}>
      <svg>
        <use xlinkHref='#icon-logo' />
      </svg>
    </div>
    <Button
      btnType='LogIn'
      style={{
        fontSize: '0.75rem',
        position: 'absolute',
        background: 'none',
        color: 'var(--main-color-text)',
        fontWeight: '400',
        top: props.isLandscape ? '0.5rem' : '0.25rem',
        right: '0',
        width: 'auto' }}
      clicked={props.gotoLogin}
    >{strings.LOGIN}
    </Button>
  </div>
);

export default hiddenNavBar;
